import styles from "./loading.module.scss";
import { Box, CircularProgress } from "@mui/material";
import classnames from "classnames";

export function Loading({ className, fullscreen, height, loading, size }) {
  if (!loading) return null;

  return (
    <Box
      className={classnames(styles.loading, className, {
        [styles.fullscreen]: fullscreen,
      })}
      sx={{ height }}
    >
      <CircularProgress size={size} />
    </Box>
  );
}
